// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__g-5fB","rightAdornment":"Header_rightAdornment__3UXrX"};